import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import tasksReducer from './slices/tasksSlice';
import recuringTasksReducer from './slices/recurringTaskSlice';
import projectsReducer from './slices/projectsSlice';
import eventsReducer from './slices/eventsSlice';
import errorReducer from './slices/apiErrorSlice';
import { socketMiddleware } from './middleware/socketMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tasks: tasksReducer,
    recurringTasks: recuringTasksReducer,
    projects: projectsReducer,
    events: eventsReducer,
    apiErrors: errorReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(socketMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;